import React, { useState } from 'react'

import { ElapsedTimeProvider } from '@pb/components'

export const TrackingStateContext = React.createContext<{
  isTriggered: boolean
  setIsTriggered: (value: boolean) => void
} | null>(null)

const ElapsedTimeTrackingProvider: React.FC = ({ children }) => {
  const [isTriggered, setIsTriggered] = useState(false)

  return (
    <ElapsedTimeProvider>
      <TrackingStateContext.Provider value={{ isTriggered, setIsTriggered }}>
        {children}
      </TrackingStateContext.Provider>
    </ElapsedTimeProvider>
  )
}

export default ElapsedTimeTrackingProvider
